import { Component, inject } from "@angular/core";
import { VdsAlert } from "@dcc/vestas-design-system/angular/components/alert/ui";
import { VdsToast } from "@dcc/vestas-design-system/angular/components/toast";
import { Events } from "@ngrx/signals/events";
import { AlertNotification, notificationEvents, TOAST_DEFAULTS, ToastNotification } from "@dcc/vestas-online/alerts/domain";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslocoService } from "@jsverse/transloco";
import { map } from "rxjs";

@Component({
    selector: "vo-alert-container",
    template: "",
    host: { class: "contents" }
})
export class AlertContainer {
    private readonly events = inject(Events);
    private readonly alert = inject(VdsAlert);
    private readonly toast = inject(VdsToast);
    private readonly transloco = inject(TranslocoService);

    constructor() {
        this.events
            .on(notificationEvents.toastShown)
            .pipe(takeUntilDestroyed())
            .subscribe(({ payload }) => this.showToast(payload));

        this.events
            .on(notificationEvents.translatedToastShown)
            .pipe(
                takeUntilDestroyed(),
                map(({ payload }) => {
                    return {
                        ...payload,
                        message: this.transloco.translate(payload.message)
                    };
                })
            )
            .subscribe((payload) => this.showToast(payload));

        this.events
            .on(notificationEvents.alertShown)
            .pipe(takeUntilDestroyed())
            .subscribe(({ payload }) => this.showAlert(payload));

        this.events
            .on(notificationEvents.translatedAlertShown)
            .pipe(
                takeUntilDestroyed(),
                map(({ payload }) => {
                    return {
                        ...payload,
                        message: this.transloco.translate(payload.message),
                        ...(payload.title ? { title: this.transloco.translate(payload.title) } : {})
                    };
                })
            )
            .subscribe((payload) => this.showAlert(payload));
    }

    private showAlert(config: AlertNotification): void {
        this.alert.open(config.title, config.message, "close", {
            alertType: config.type,
            ...(config.verticalPosition ? { verticalPosition: config.verticalPosition } : {}),
            ...(config.duration ? { duration: config.duration } : {})
        });
    }

    private showToast(config: ToastNotification): void {
        this.toast.open(config.message, "close", {
            ...TOAST_DEFAULTS,
            type: config.type,
            ...(config.duration ? { duration: config.duration } : {}),
            ...(config.horizontalPosition ? { horizontalPosition: config.horizontalPosition } : {}),
            ...(config.verticalPosition ? { verticalPosition: config.verticalPosition } : {})
        });
    }
}
